<template>
  <div class="buyerShop">
    <h1 class="mb20">{{ $t('crm.editAudit') }}</h1>
    <p>{{ $t('crm.applicant') }}</p>
    <p class="f18 mb20">{{ applyUserName }}</p>
    <p>{{ $t('crm.applyTime') }}</p>
    <p class="f18 mb20">{{ dateFormat(applyTime) }}</p>
    <p>{{ $t('crm.editcontent') }}：</p>

    <el-card class="box-card" shadow="hover" v-if="vendorContactsInfoShow">
      <h2 slot="header">{{ $t('crm.vendorContacts') }}</h2>
      <el-table :data="after.vendorContacts" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
        <el-table-column :label="$t('crm.vendorContacts')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ $t('crm.vendorContacts') }}{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactName" :label="$t('crm.mainContactName')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ scope.row.contactName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactTitle" :label="$t('crm.mainContactTitle')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ scope.row.contactTitle }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm.mainContact')">
          <template slot-scope="scope">
            <p :class="{delete: item.delete, red: item.red}" v-for="(item, index) in scope.row.contactList" :key="index">{{ contactTypeMap[item.contactType] }}: {{ item.contactNo }}</p>
          </template>
        </el-table-column>
        <el-table-column :label="$t('crm.mainContactReponseSpeed')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ scoreListMap[scope.row.contactResponseSpeed] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactResponsibleFor" :label="$t('crm.mainContactResponsiblefor')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ contactResponsibleForMap[scope.row.contactResponsibleFor] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contactNegotiationStyle" :label="$t('crm.mainContactNegotitationStyle')">
          <template slot-scope="scope">
            <span :class="{delete: scope.row.delete, red: scope.row.red}">{{ scope.row.contactNegotiationStyle }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card" shadow="hover" v-if="paymentShow">
      <h2 slot="header">{{ $t('crm.payment') }}</h2>
      <div class="info-group">
        <div class="info-item" v-if="before.paymentInfoReqVo.paymentMethod !== after.paymentInfoReqVo.paymentMethod">
          <label>{{ $t('crm.paymentMethod') }}</label>
          <div class="value">
            <span class="delete">{{ paymentMethodListMap[before.paymentInfoReqVo.paymentMethod] }}</span>
            <span class="red">{{ paymentMethodListMap[after.paymentInfoReqVo.paymentMethod] }}</span>
          </div>
        </div>
        <div class="info-item" v-if="before.paymentInfoReqVo.depositAmount !== after.paymentInfoReqVo.depositAmount">
          <label>{{ $t('crm.depositAmount') }}</label>
          <div class="value">
            <span class="delete">{{ before.paymentInfoReqVo.depositAmount }}</span>
            <span class="red">{{ after.paymentInfoReqVo.depositAmount }}</span>
          </div>
        </div>
        <div class="info-item" v-if="before.paymentInfoReqVo.paymentTiming !== after.paymentInfoReqVo.paymentTiming || (after.paymentInfoReqVo.paymentTiming === 'crm_payment_others' && before.paymentInfoReqVo.paymentTimingRemark !== after.paymentInfoReqVo.paymentTimingRemark)">
          <label>{{ $t('crm.paymentTiming') }}</label>
          <div class="value">
            <template v-if="before.paymentInfoReqVo.paymentTiming !== after.paymentInfoReqVo.paymentTiming">
              <span class="delete">{{ paymentTimingListMap[before.paymentInfoReqVo.paymentTiming] }}</span><span class="red">{{ paymentTimingListMap[after.paymentInfoReqVo.paymentTiming] }}</span>
            </template>
            <template v-if="before.paymentInfoReqVo.paymentTiming === after.paymentInfoReqVo.paymentTiming">
              {{ paymentTimingListMap[after.paymentInfoReqVo.paymentTiming] }}
            </template>
            <template v-if="after.paymentInfoReqVo.paymentTiming === 'crm_payment_others' && before.paymentInfoReqVo.paymentTimingRemark !== after.paymentInfoReqVo.paymentTimingRemark">
              (
              <span class="delete">{{ before.paymentInfoReqVo.paymentTimingRemark }}</span>
              <span class="red">{{ after.paymentInfoReqVo.paymentTimingRemark }}</span>
              )
            </template>
          </div>
        </div>
        <div class="info-item" v-if="after.paymentInfoReqVo.paymentTiming === 'crm_payment_week' && before.paymentInfoReqVo.paymentTimingTime !== after.paymentInfoReqVo.paymentTimingTime">
          <label>{{ $t('crm.settlementCycle') }}</label>
          <div class="value">
            <span class="delete">{{before.paymentInfoReqVo.paymentTimingTime ? $t('common.week' + (before.paymentInfoReqVo.paymentTimingTime - 1)) : '' }}</span>
            <span class="red">{{ $t('common.week' + (after.paymentInfoReqVo.paymentTimingTime - 1)) }}</span>
          </div>
        </div>

        <div class="info-item" v-if="before.paymentInfoReqVo.paymentMethodRemark !== after.paymentInfoReqVo.paymentMethodRemark">
          <label>{{ $t('crm.paymentRemark') }}</label>
          <div class="value">
            <span class="delete">{{ before.paymentInfoReqVo.paymentMethodRemark }}</span>
            <span class="red">{{ after.paymentInfoReqVo.paymentMethodRemark }}</span>
          </div>
        </div>
        <div class="info-item" v-if="before.paymentInfoReqVo.settleCurrency !== after.paymentInfoReqVo.settleCurrency">
          <label>{{ $t('crm.vendorSettlementCurrency') }}</label>
          <div class="value">
            <span class="delete">{{ before.paymentInfoReqVo.settleCurrency }}</span>
            <span class="red">{{ after.paymentInfoReqVo.settleCurrency }}</span>
          </div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card" shadow="hover" v-if="payeeInfoShow">
      <h2 slot="header">{{ $t('crm.payeeInfo') }}</h2>
      <el-table :data="after.receivePaymentReqVos" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
        <el-table-column prop="payeeName" :label="$t('crm.payeeName')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.payeeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankOfName" :label="$t('crm.bankName')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.bankOfName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankAccountNo" :label="$t('crm.bankAccount')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.bankAccountNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankAddress" :label="$t('crm.bankAddress')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.bankAddress }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="swiftCode" :label="$t('crm.swiftCode')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.swiftCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="iban" :label="$t('crm.iban')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.iban }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="payType" :label="$t('crm.payMethod')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.payType === 1 ? $t('crm.overseaPayment') : scope.row.payType === 2 ? $t('crm.domesticPayment') : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="idNo" :label="$t('crm.idNumber')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.idNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phoneNum" :label="$t('crm.phoneNumber')">
          <template slot-scope="scope">
            <span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{ scope.row.phoneNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="defaultOption" :label="$t('crm.defaultOption')">
          <template slot-scope="scope"><span :class="{delete: !scope.row.enabled, red: !scope.row.vendorPaymentId}">{{scope.row.defaultOption === 1 ? $t('common.yes') : scope.row.defaultOption === 0 ? $t('common.no') : "" }}</span></template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="footer-bar">
      <p class="blue">{{ $t('crm.auditSubmitTip') }}</p>
      <div>
        <el-button type="primary" @click="submitPass">{{ $t('crm.passTheAudit') }}</el-button>
        <el-button @click="submitDismiss">{{ $t('crm.dismiss') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictList,
  getVendorAuditShowDetail,
  approvalAudit,
  getEmailContentType,
} from './api';
import {
  getBusinessRegionList,
  getUserList,
  getVendorType,
  getBoutiqueCountryList,
  queryStockLocation,
} from '../buyershop/api';
import utils from '@/utils/util';
import _ from "lodash";
import { af } from 'date-fns/locale';

export default {
  components: {
  },
  data() {
    return {
      operationTypeList: [],
      vendorTypeList: [],
      productSourceTypeMap: {},
      detail: {},
      before: {
        vendorExtReqVo: {},
        paymentInfoReqVo: {},
        invoiceReqVo: {},
        saleChannelReqVos: [],
        receivePaymentReqVos: [],
        vendorContacts: [],
      },
      after: {
        vendorExtReqVo: {},
        paymentInfoReqVo: {},
        invoiceReqVo: {},
        saleChannelReqVos: [],
        receivePaymentReqVos: [],
        vendorContacts: [],
      },
      applyTime: null,
      applyUserName: null,
      contactTypeMap: {},
      scoreListMap: {},
      paymentMethodListMap: {},
      paymentTimingListMap: {},
      contactResponsibleForMap: {},
      stockChannelListMap: {},
      visitCountListMap: {},
      assistantMap: {},
      businessRegionMap: {},
      supplyPriceMethodMap: {},
      emailContentMap: {},
      countryIdMap: {},
      countryListMap: {},
      comboMap: {},
      taxMap: {
        1: this.$t('crm.taxIncluded'),
        2: this.$t('crm.taxExcluded'),
      },
      drawbackMap: {
        1: this.$t('crm.taxRefund'),
        0: this.$t('crm.noTaxRefund'),
      },
      yesOrNoMap: {
        1: this.$t('common.yes'),
        0: this.$t('common.no'),
      },
      hasRetailStoreYesOrNoMap: {
        1: this.$t('crm.hasRetailStore1'),
        0: this.$t('crm.hasRetailStore0'),
      },
      isPerSaleMap: {
        1: this.$t('crm.support'),
        2: this.$t('crm.notSupport'),
        3: this.$t('crm.rollingPreSale'),
      },
      hasChannelMap: {
        1: 'hasEcWebsite',
        2: 'hasWholesaleBusiness',
        3: 'hasFarfetch',
        4: 'hasDewu',
      },
      channelMap: {
        1: 'ecWebsite',
        2: 'wholesaleBusiness',
        3: 'farfetch',
        4: 'dewu',
      },
      usingMap: {
        1: this.$t('crm.using'),
        2: this.$t('crm.terminated'),
      },
      stockChannelDiff: [],
      vendorInfoShow: false,
      stockLocationShow: false,
      boutiqueAftermarketEmailShow: false,
      mailDefectLevelConfigVosShow: false,
      vendorEvaluationShow: false,
      paymentShow: false,
      pricingInfoShow: false,
      billingInfoShow: false,
      payeeInfoShow: false,
      visitInfoShow: false,
      retailStoreShow: false,
      otherSalesChannelsShow: false,
      saleChannelReqVosShow: false,
      fulfillmentShow: false,
      vendorContactsInfoShow: false,
      deliveryTimeShow: false,
      beforeLevelCode: [],
      afterLevelCode: [],
      beforeDeliveryTime: [],
      afterDeliveryTime: [],
      vendorOrderPushEmailShow: false,
    };
  },
  async mounted() {
    this.init();
    await getEmailContentType().then(res => {
      if (res.data && res.data.success) {
        this.contentTypeList = (res.data.data || []).map(item => ({
          code: item.code,
          explain: item.explain,
          checked: true,
        }));
        const map = {};
        (res.data.data || []).forEach(item => {
          map[item.code] = item.explain;
        })
        this.emailContentMap = map;
      }
    })
    getVendorAuditShowDetail({
      vendorId: this.$route.params.id,
      status: 0,
    }).then(res => {
      if (res.data && res.data.success && res.data.data) {
        try {
          const before = JSON.parse(res.data.data.modifyContentBefore);
          const after = JSON.parse(res.data.data.modifyContentAfter);
          this.before = before;
          this.after = after;
          this.applyUserName = res.data.data.applyUserName;
          this.applyTime = res.data.data.applyTime;
          this.id = res.data.data.crmVendorModifyAuditId;
          this.formatForm();
        } catch (error) {
          this.$message.error(this.$t('common.systemError'));
        }
      }
    });
  },
  methods: {
    formatForm() {
      if (this.before.paymentInfoReqVo.paymentMethod !== this.after.paymentInfoReqVo.paymentMethod) {
        this.paymentShow = true;
      }
      if (this.before.paymentInfoReqVo.depositAmount !== this.after.paymentInfoReqVo.depositAmount) {
        this.paymentShow = true;
      }
      if (this.before.paymentInfoReqVo.paymentTiming !== this.after.paymentInfoReqVo.paymentTiming) {
        this.paymentShow = true;
      }
      if (this.after.paymentInfoReqVo.paymentTiming === 'crm_payment_others' && this.before.paymentInfoReqVo.paymentTimingRemark !== this.after.paymentInfoReqVo.paymentTimingRemark) {
        this.paymentShow = true;
      }
      if (this.before.paymentInfoReqVo.paymentMethodRemark !== this.after.paymentInfoReqVo.paymentMethodRemark) {
        this.paymentShow = true;
      }

      if (this.before.paymentInfoReqVo.settleCurrency !== this.after.paymentInfoReqVo.settleCurrency) {
        this.paymentShow = true;
      }
      if (this.before.paymentInfoReqVo.paymentTimingTime !== this.after.paymentInfoReqVo.paymentTimingTime) {
        this.paymentShow = true;
      }
      this.payeeInfoShow = this.after.receivePaymentReqVos.some(item => {
        if (!item.vendorPaymentId || !item.enabled) {
          return true;
        }
        const payee = this.before.receivePaymentReqVos.filter(bitem => bitem.vendorPaymentId === item.vendorPaymentId);
        if (payee[0] && !_.isEqual(payee[0], item)) {
          return true;
        }
        return false;
      });
    },
    init() {
      getDictList({
        parentCode: 'product_source_type',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.productSourceTypeMap = map;
        }
      });
      getDictList({
        parentCode: 'supply_price_method',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.supplyPriceMethodMap = map;
        }
      });
      getBusinessRegionList().then(res => {
        if (res.data.data) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.businessRegionId] = item.businessRegionName;
          })
          this.businessRegionMap = map;
        }
      });
      getUserList({
      }).then(res => {
        if (res.success && res.data) {
          const map = {};
          (res.data || []).forEach(item => {
            map[item.deptUserId] = item.deptUserName;
          })
          this.assistantMap = map;
        }
      });
      getVendorType().then(res => {
        if (res.data) {
          this.vendorTypeList = res.data.data;
        }
      });
      getDictList({
        parentCode: 'vendor_operation_type',
      }).then(res => {
        if (res.data && res.data.success) {
          this.operationTypeList = res.data.data || [];
        }
      });
      getDictList({
        parentCode: 'crm_score',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.scoreListMap = map;
        }
      });
      getDictList({
        parentCode: 'crm_payment_method',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.paymentMethodListMap = map;
        }
      });
      getDictList({
        parentCode: 'crm_payment_timing',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.paymentTimingListMap = map;
        }
      });
      getDictList({
        parentCode: 'contact_responsible_for',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.contactResponsibleForMap = map;
        }
      });
      getDictList({
        parentCode: 'contact_information_type',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.contactTypeMap = map;
        }
      });
      getDictList({
        parentCode: 'crm_stock_channel',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.stockChannelListMap = map;
        }
      });
      getDictList({
        parentCode: 'quarter_visit_count',
      }).then(res => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.data || []).forEach(item => {
            map[item.dictCode] = item.dictValue;
          })
          this.visitCountListMap = map;
        }
      });
      getBoutiqueCountryList().then(res => {
        if (res.data) {
          const map = {};
          const map2 = {};
          this.countryList = (res.data.data || []).map(item => {
            map[item.countryCode] = item.name;
            map2[item.addressCountryId] = item.name;
            return item;
          }).filter(item => {
            if (item.addressCountryId != 100) {
              return true;
            }
            return false;
          });
          this.countryIdMap = map2;
          this.countryListMap = map;
        }
      });
      queryStockLocation({
        vendorId: this.$route.params.id
      }).then(res => {
        if (res.data && res.data.data) {
          const map = { '-1': 'self' };
          res.data.data.map((item) => {
            map[item.locationId] = item.stockLocation;
            return item;
          });
          this.comboMap = map;
        }
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    dateFormat2(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd');
    },
    submitPass() {
      this.$confirm(`<span style="color:red">${this.$t('crm.auditPassTip')}</span>${this.$t('crm.doYouContinue')}`, this.$t('crm.auditPassConfirmTip'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        approvalAudit({
          vendorId: this.$route.params.id,
          id: this.id,
          status: 1,
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(this.$t('common.submitSuccess'));
            this.$router.push({
              path: '/crm/list',
            });
          } else {
            this.$message.error(res.data.message || this.$t('common.systemError'));
          }
        })
      }).catch(() => {});
    },
    submitDismiss() {
      this.$confirm(`<span style="color:red">${this.$t('crm.auditDismiss')}</span>${this.$t('crm.doYouContinue')}`, this.$t('crm.auditDismissConfirmTip'), {
        confirmButtonText: this.$t('common.ok'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true,
      }).then(() => {
        approvalAudit({
          vendorId: this.$route.params.id,
          id: this.id,
          status: 2,
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success(this.$t('common.submitSuccess'));
            this.$router.push({
              path: '/crm/list',
            });
          } else {
            this.$message.error(res.data.message || this.$t('common.systemError'));
          }
        })
      }).catch(() => {});
    },
    formatOperationType(_){
      if (!_) {
        return '';
      }
      const curItem = this.operationTypeList.find(element=>element.dictCode == _);
      return curItem.dictValue
    },
    formatVendorType(_){
      if (!_) {
        return '';
      }
      const curItem = this.vendorTypeList.find(element=>element.value == _);
      return curItem.desc
    },
    emailContentMapFnc(_){
      let emailContentArr = [];
      if(_&&_.length) {
        _ = _.split(',')
      }
      _.map(item=>{
        emailContentArr.push(this.emailContentMap[item])
      })
      return emailContentArr.toString();
    },

  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  padding: 20px 20px 100px 20px;

  .footer-bar {
    position: fixed;
    right: 20px;
    bottom: 0;
    left: 210px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    transition: left 0.3s;
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px 0 0;
    z-index: 10;
  }
}
.box-card {
  margin-bottom: 20px;
}
.form-btn {
  margin-top: 40px;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.mr10 {
  margin-right: 10px;
}
.f18 {
  font-size: 18px;
}
.tr {
  text-align: right;
}
.delete {
  margin-right: 5px;
  text-decoration: line-through;
}
.red {
  color: red;
}
.blue {
  color: #409EFF;
}
.info-group {
  display: flex;
  flex-wrap: wrap;
}
.info-item {
  display: flex;
  width: 50%;
  line-height: 20px;

  label {
    flex: 0 0 auto;
    width: 200px;
    padding: 10px;
    background-color: #f9f9f9;
    border: 1px solid #EBEEF5;
  }
  .value {
    flex: 1;
    padding: 10px;
    border-top: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  &:nth-child(even) {
    label {
      border-left: 0;
    }
  }
  &:nth-child(n+3) {
    label {
      border-top: 0;
    }
    .value {
      border-top: 0;
    }
  }
  &.full {
    width: 100%;

    label {
      // border-bottom: 0;
    }
    .value {
      // border-bottom: 0;
    }
  }
}
</style>
